import React from 'react';
import Chart from '../../../models/chart';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ContextMenu, Button, DropdownItem } from '@weezevent/nacre';
import NavTitle from './NavTitle';

export default function ChartContextMenu({ organization, chart }) {
    const { t } = useTranslation();
    const history = useHistory();
    const [search, setSearch] = React.useState(null);

    const [charts] = Chart.useApiModel(
        {
            organizationId: organization.id,
            query: {
                only_seated: true,
                search
            }
        },
        [organization, search]
    );

    const handleSwitch = React.useCallback(
        chart => {
            history.push(`/ticket/O${organization.id}/charts/${chart.uuid}/dashboard`);
        },
        [history, organization, chart]
    );

    const handleRoot = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/charts/${chart.uuid}/inventories/new`);
    }, [history, organization, chart]);

    const chartList = React.useMemo(() => {
        let list = [];
        charts?.forEach(chart => {
            list.push(
                <DropdownItem key={chart.uuid} onClick={() => handleSwitch(chart)}>
                    {chart.name}
                </DropdownItem>
            );
        });
        return list;
    }, [charts, handleSwitch]);

    const handleSearch = React.useCallback(query => {
        setSearch(query || null);
    }, []);

    const defaultTooltipProps = {
        margin: false,
        triggerOnHover: true,
        position: 'top-start'
    };

    return (
        <ContextMenu
            catchphrase={<NavTitle title={t('ticket.charts.chart.charts')} link={`/ticket/O${organization.id}/charts`} />}
            title={chart.name}
            titleTooltipProps={{ ...defaultTooltipProps, title: chart.name, position: 'bottom-start', offset: [0, -5] }}
            cta={
                <Button fluid onClick={handleRoot} primary>
                    {t('context_menu.cta_label_chart')}
                </Button>
            }
            switchMenuProps={{
                footerText: t('ticket.switchChart.footer_cta'),
                onFooterClick: () => history.push(`/ticket/O${organization.id}/charts`),
                searchProps: {
                    onChange: (synth, val) => {
                        handleSearch(val);
                    },
                    placeholder: t('ticket.switchChart.search_placeholder')
                },
                text: t('ticket.switchChart.cta'),
                items: chartList
            }}
        />
    );
}
